import React, { FunctionComponent, useEffect, useState } from "react";
import "./AdminRightSideAd.scss";
import images from "../../assets/images";
import { useAppSelector } from "../../redux/app/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import axios, { AxiosResponse } from "axios";
import Slideshow from "./components/SlideShow";
import { CircularProgress } from "@mui/material";
import { PATH_ADDRESSES, SCHOOL_ADMIN } from "../../utils/constants";
import { trackButtonClick } from "../../firebase/analyticsHelper";
import { ButtonClickEvents } from "../../firebase/constants/events";

export interface Advertisement {
  title: string;
  Screen: string;
  Image: string;
  categories: string[];
}

export type ScreenImages = {
  screen: string;
  images: string[];
};

export const getPtaContainer = (navigate: any) => {

  const { PTA_Background } = images;

  const handleClick = () => {
    trackButtonClick(ButtonClickEvents?.PTA_BOX_CLICK, {
        description : "User clicked the PTA box",
        page: 'AdminDashboard'
    });
    
    navigate("/admin-pta");
  };

  return (
    <div className="adminRightSidePTA" onClick={handleClick}>
      <img className="adminRightSidePTAbg" alt="ptaBg" src={PTA_Background} />
      <div className="adminRightSidePtaTextContainer">
        <label htmlFor="pta-text" className="ptaLabel">
          PTA
        </label>
        <p className="clickHereForContainer">
          <span className="clickHereFor">Click here for Parent and</span>
          <span className="clickHereFor">Teachers blog</span>
        </p>
      </div>
    </div>
  );
}

const AdminRightSideAd: FunctionComponent = () => {
  // get isVisible from the redux to hide the Ad.
  const isVisible = useAppSelector((state) => state.rightSideAd.isVisible);
  const adComponent = useAppSelector((state) => state.rightSideAd.adComponent);
  const navigate = useNavigate();
  const [advertisements, setAdvertisement] = useState<string[]>([]);
  const [screenImages, setScreenImages] = useState<ScreenImages[]>([]);
  const katonCms = process.env.REACT_APP_KATON_CMS_SITE;
  const location = useLocation()
  const tabs = localStorage.getItem('adminDashboardTabIndex') || '0'
  const [loading,setLoading] = useState<boolean>(false)
  const { role, loginpage } = useAppSelector((state) => state.auth);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const response: AxiosResponse<Advertisement[]> = await axios.get(
          `${katonCms}/class_room_advertisement`,
          {
            headers: {
              "X-Hash-Key": process.env.REACT_APP_KATON_SITE_API_KEY,
            },
          }
        );
        const advertisementsData = response.data;
        const localStorageRole = localStorage.getItem("role") || "";

        const schoolAdminScreens: Record<string, string[]> = advertisementsData
          .filter((ad: Advertisement) =>
            ad.categories
              .map((category) => category.toLowerCase())
              .includes(localStorageRole)
          )
          .reduce((acc: Record<string, string[]>, ad: Advertisement) => {
            const { Screen, Image } = ad;
            if (!acc[Screen]) {
              acc[Screen] = [];
            }
            acc[Screen].push(`${katonCms?.split("/wp-json")[0]}${Image}`);
            return acc;
          }, {});

        const result: ScreenImages[] = Object.keys(schoolAdminScreens).map(
          (screen: string) => ({
            screen,
            images: schoolAdminScreens[screen],
          })
        );
        setScreenImages(result)
      } catch (error) {
        console.log(error);
      }finally {
        setLoading(false); // Stop the loader
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleAdvertisement = () => {
  
      const lowercaseScreen = (screen: string) => screen.toLowerCase();
      let adValue: ScreenImages | undefined;
      if (location.pathname === PATH_ADDRESSES?.ADMIN_DASHBOARD_PATH) {
        switch (tabs) {
              case '0':
                  adValue = screenImages.find(ad => lowercaseScreen(ad.screen) === "teachers");
                  break;
              case '1':
                  adValue = screenImages.find(ad => lowercaseScreen(ad.screen) === "students");
                  break;
              case '2':
                  adValue = screenImages.find(ad => lowercaseScreen(ad.screen) === "classroom");
                  break;
              case '3':
                  adValue = screenImages.find(ad => lowercaseScreen(ad.screen) === "announcement");
                  break;
              default:
                  adValue = undefined;
                  break;
          }
      } else if (location.pathname === '/admin-notification') {
          adValue = screenImages.find(ad => lowercaseScreen(ad.screen) === "notification");
      }
      else if (location.pathname.includes('/admin-materials-upload')) {
          adValue = screenImages.find(ad => lowercaseScreen(ad.screen) === "teachers");
      }else if (location.pathname === '/admin-system-message') {
        adValue = screenImages.find(ad => lowercaseScreen(ad.screen) === "systemmessages");
      }else if (location.pathname === '/admin-settings') {
        adValue = screenImages.find(ad => lowercaseScreen(ad.screen) === "settings");
      }else if (location.pathname === '/admin-help') {
        adValue = screenImages.find(ad => lowercaseScreen(ad.screen) === "help");
      }else if (location.pathname === '/admin-workshop' || location.pathname === '/facilitator-workshop') {
        adValue = screenImages.find(ad => lowercaseScreen(ad.screen) === "notification");
      }else if (location.pathname === '/admin-payments') {
        adValue = screenImages.find(ad => lowercaseScreen(ad.screen) === "payments") || screenImages.find(ad => lowercaseScreen(ad.screen) === "notification");
      }
  
      if (adValue) {
          setAdvertisement(adValue.images);
      } else {
          setAdvertisement([]);
      }
  };
    handleAdvertisement();
}, [location.pathname, tabs,screenImages, adComponent]);


  return (
    <div
      className={`${isVisible ? "adminRightSideAdMainContainer" : "hideAds"}`}
    >
      {(role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN) && getPtaContainer(navigate)}
      <div className= {advertisements.length > 0  ? 'adminRightSideAd' : 'loader'} >
        {/* <img className="adminRightSideAdbg" alt="AdImage" src={schooladminAd} /> */}
        {advertisements.length === 1 ? (
          <img
            src={advertisements[0]}
            alt="Single Advertisement"
            className={"adminRightSideAdbg"}
          />
        ) : advertisements.length > 1 ? (
          <Slideshow images={advertisements} />
        ) : (
          loading && <CircularProgress color="inherit" size={20} />
        )}
        {/* <div className="adminRightSideAdbg" style={{ backgroundImage: "url(" + rightSideAdImages[adImage] + ")" }} /> */}
      </div>
    </div>
  );
};

export default AdminRightSideAd;
